module.exports = __webpack_public_path__ + "static/img/0_1_5.f2e4ae1c.jpg";